import React from "react";
import { AlertsContextType } from "./types";

export const AlertsAPIContext = React.createContext<AlertsContextType>({
  alerts: [],
  addAlert: () => {},
  removeAlert: () => {},
});
